import API_BASE_URL from '../config';
import { getToken } from './authService';

let categoriesPromise = null;
let basicCategoriesPromise = null;

export async function getCategories(forceRefresh = false) {
  if (forceRefresh) categoriesPromise = null;
  if (categoriesPromise) return categoriesPromise;
  categoriesPromise = fetch(`${API_BASE_URL}/categories`).then(res => res.json()).catch(err => {
    categoriesPromise = null; // reset on error
    throw err;
  });
  return categoriesPromise;
}

export async function getBasicCategories(forceRefresh = false) {
  if (forceRefresh) basicCategoriesPromise = null;
  if (basicCategoriesPromise) return basicCategoriesPromise;
  basicCategoriesPromise = fetch(`${API_BASE_URL}/categories?basic=true`).then(res => res.json()).catch(err => {
    basicCategoriesPromise = null;
    throw err;
  });
  return basicCategoriesPromise;
}

export async function getCategoryById(id) {
  const res = await fetch(`${API_BASE_URL}/categories/${id}`);
  return res.json();
}

export async function addCategory(fd) {
  const token = getToken();
  const res = await fetch(`${API_BASE_URL}/categories`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: fd,
  });
  return res.json();
}

export async function updateCategory(id, fd) {
  const token = getToken();
  const res = await fetch(`${API_BASE_URL}/categories/${id}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: fd,
  });
  return res.json();
}

export async function deleteCategory(id) {
  const token = getToken();
  const res = await fetch(`${API_BASE_URL}/categories/${id}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.json();
}
export async function reorderCategories(orders) {
  const token = getToken();
  const res = await fetch(`${API_BASE_URL}/categories/reorder`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ orders }),
  });
  categoriesPromise = null; // Clear cache after reordering
  return res.json();
}

/**
 * Helper to get the full category path (array of category objects) by a leaf ID.
 */
export async function getCategoryPathById(leafId, tree) {
  if (!leafId) return [];
  const nodes = tree || await getCategories();

  function find(list, id, path = []) {
    for (const n of list) {
      const currentPath = [...path, n];
      if (String(n.id) === String(id)) return currentPath;
      if (n.subcategories && n.subcategories.length) {
        const found = find(n.subcategories, id, currentPath);
        if (found) return found;
      }
    }
    return null;
  }

  return find(nodes, leafId) || [];
}
